

<div class="confirmGrid">

    <kendo-pdf-export #pdf paperSize="A4" class="pdfExportReport" [scale]="0.4"  keepTogether="tr" [landscape]="true">
        <kendo-pdf-export-margin top="1cm" bottom="0cm" left="1cm" right="1cm" ></kendo-pdf-export-margin>
    <div class="reportHeader" id="head-reportHeader">

        <img class="orderThankyou" src="assets/theme/mclane/img/McLane_logo_rgb.png"/>

        <div *ngIf="store" class="informationPanel" id="head-informationPanel">
            <p>SourceLink&trade;</p>
            <p>Order Review - {{dateToday}}</p>
            <p>Order Submitted - {{datedelivery}}</p>
            <p>Store #{{store.customerId}} - {{store.identity}}</p>
            <p>{{ store.address }}</p>
            <p>{{store.city}}, {{ store.state}} {{store.zip}}</p>

        </div>
    </div>
        <div class="review-buttonHolder">
        <app-mcl-button class="exportButton" [text]="'Export to PDF'" [svgIcon]='filePdfIcon' (buttonPressed)="pdf.saveAs('OrderReport.pdf')" primary="true"  ></app-mcl-button>
            <app-mcl-button class="exportButton" [text]="'Export to Excel'" [svgIcon]="fileExcelIcon"  (buttonPressed)="exportToExcel(reviewGrid)" primary="true"  ></app-mcl-button>
        </div>
    <div *ngIf="confirmationMessagesEnabled" class="confirmationMessage orderConfirmGrid"
         id="grid-confirmationMessages">
        <h1 class="groupHeader">Confirmation Messages</h1>
        <kendo-grid [data]="confirmationMessages"  >
            <kendo-grid-excel ></kendo-grid-excel>
            <kendo-grid-column *ngFor="let col of confirmationColumns" [editable]="true" [field]="col.key"
                               [format]="col.format" [title]="col.title">

                <ng-template *ngIf="col.footer" kendoGridFooterTemplate let-column let-columnIndex="columnIndex">
                   <span> {{col.title}}
                   </span> Total: {{col.currency ? (sumItemGroups(col.key, 2) | currency)
                    : (sumItemGroups(col.key, 2))  }}
                </ng-template>
            </kendo-grid-column>
        </kendo-grid>
    </div>

        <div class="orderConfirmGrid" id="grid-orderConfirm">
        <h1 class="groupHeader">Order Review</h1>
        <kendo-grid  #reviewGrid [data]="gridData" class="reviewGrid" (excelExport)="excelExported($event)" >
            <kendo-grid-excel [fetchData]="exportMainGrid" [fileName]="'OrderReview.xlsx'">
            </kendo-grid-excel>
            <kendo-grid-column *ngFor="let col of columns" [field]="col.key" [format]="col.format" [title]="col.title" class="reportFormat" [autoSize]="true"  >
                <ng-template *ngIf="col.footer" kendoGridFooterTemplate let-column let-columnIndex="columnIndex">
                    <span> {{ col.footerDesc ? col.footerDesc : col.title}}</span>
                    Total: {{col.currency ? (sumItemGroups(col.key, 1) | currency)
                    : (sumItemGroups(col.key, 1))  }}
                </ng-template>
            </kendo-grid-column>
        </kendo-grid>
        </div>
    </kendo-pdf-export>
</div>
<div kendoDialogContainer></div>

